import { PopupMessage } from 'src/interfaces'

interface BulkResultItem {
  uniqueId: string
  status: string
  message?: string
}

export const buildBulkResultMessages = (
  results: BulkResultItem[],
  successText: (count: number) => string,
  errorText: (uniqueId: string, message: string) => string,
): PopupMessage[] => {
  const succeeded = results.filter((item) => item.status === 'ok').length
  const failed = results.filter((item) => item.status !== 'ok')
  const messages: PopupMessage[] = []

  if (succeeded > 0) {
    messages.push({ text: successText(succeeded), type: 'success' })
  }
  for (const item of failed) {
    messages.push({ text: errorText(item.uniqueId, item.message || ''), type: 'error' })
  }

  return messages
}
